import React from 'react'
import { connect } from 'react-redux'
import HomeLoan from './HomeLoan'
import Repayment from './Repayment'
import Credit from './Credit'
import Other from './Other'
import GreyBig from '../GreyBig'

class Commitments extends React.Component {
  render() {
    const { review, loanApplicationUser } = this.props

    return (
      <div className='card card-single'>
        <div className='card-header'>
          <div className='pull-right'>
            <a className='smaller' href='#' onClick={ () => this.props.onGoToClick('commitments')}>Edit</a>
          </div>
          Loan commitments
        </div>
        <div className='card-body'>
          { review.commitments.map((commitment, index) => {
              if (commitment.option === 'home_loan') {
                return ( <HomeLoan commitment={commitment} key={index} /> )
              } else if (commitment.option === 'line_of_credit') {
                return ( <Credit commitment={commitment} title='Line of credit' key={index} /> )
              } else if (commitment.option === 'credit_card') {
                return ( <Credit commitment={commitment} title='Credit card' key={index} /> )
              } else if (commitment.option === 'personal_loan') {
                return ( <Repayment commitment={commitment} title='Personal loan' key={index}/> )
              } else if (commitment.option === 'car_loan') {
                return ( <Repayment commitment={commitment} title='Car loan' key={index}/> )
              } else if (commitment.option === 'post_payment_facility') {
                return ( <Credit commitment={commitment} title='Post-payment facility' key={index}/> )
              } else if (commitment.option === 'educational_loan') {
                return ( <Repayment commitment={commitment} title='Education loan (HECS, HELP)' key={index}/> )
              } else if (commitment.option === 'other') {
                return ( <Other commitment={commitment} title='Other' key={index}/> )
              }
            })
          }

          <GreyBig capitalizeFirstLetter='true' size='4' grey='Credit history' big={loanApplicationUser.creditHistory}/>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  review: state.review,
  loanApplicationUser: state.loanApplicationUser.primary,
})

export default connect(mapStateToProps, {
})(Commitments)
